import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import Payment from "../pages/payment/page";
import Contact from "../pages/contact/page";
import Login from "../pages/login/page";
import FAQ from "../pages/faq/page";
import Movies from "../pages/movies/page";
import MovieDetail from "../pages/movie-detail/page";
import TrackOrder from "../pages/track-order/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/movies",
    element: <Movies />,
  },
  {
    path: "/movies/:id",
    element: <MovieDetail />,
  },
  {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/track-order",
    element: <TrackOrder />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
